// extracted by mini-css-extract-plugin
module.exports = {"page":"StyledPageBackground_page__1FU6A","pane":"StyledPageBackground_pane__v6e7z"};